export const LocalStorageKeys = {
  APPLICATION_STORE: 'fairlo.applicationStore',
  AUTH_STORE: 'fairlo.authStore',
  LAST_INITIATED_AUTOSTART_TOKEN: 'fairlo.lastInitiatedAutostartToken',
  DEVTOOLS: 'fairlo.devtools',
  DEVTOOLS_STORE: 'fairlo.devtools.store',
  DEVTOOLS_FORM_EMAIL: 'fairlo.devtools.formEmail',
  DEVTOOLS_FORM_AGE: 'fairlo.devtools.formAge',
  DEVTOOLS_OTP_EMAIL: 'fairlo.devtools.otpEmail',
  LAST_COMPLETED_ORDER_ID: 'fairlo.lastCompletedOrderId',
  USER_ID: 'fairlo.userId',
  BROKER_APPLICATION_STORE: 'fairlo.brokerApplicationStore',
} as const;
